import { NgModule } from '@angular/core';
import { NkMomentDateTimeModule } from './moment-date-time.module';
import { RangeDateTimeAdapter } from './range-date-time-adapter';
import { NkMomentRangeDateTimeAdapter } from './range-moment-date-time-adapter';

@NgModule({
  imports: [NkMomentDateTimeModule],
  exports: [NkMomentDateTimeModule],
  providers: [{ provide: RangeDateTimeAdapter, useClass: NkMomentRangeDateTimeAdapter }]
})
export class NkMomentRangeDateTimeModule {}
